import mockSdk from './BrillenSdkModule.mock'

export default mockSdk
